module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-costume-680a741760440f1dc4fedc8b5a20196f.jpg";